import { render } from "./InvoiceDetailPage.vue?vue&type=template&id=323c91f5&scoped=true"
import script from "./InvoiceDetailPage.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailPage.vue?vue&type=script&lang=js"

import "./InvoiceDetailPage.vue?vue&type=style&index=0&id=323c91f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323c91f5"]])

export default __exports__